import { Slide } from "@jelly/lesson";

const principle: Slide = {
  title: "Introduction",
  layout: {
    type: "customCase010201",
    options: {
      description: `The purpose of this case study is to present how to measure the sound reduction index of a panel using intensimetry.<br>
      <br>
      Therefore, Intensity and Sound reduction index are first described and the equipment is presented.<br>
      <br>
      A step-by-step description of an actual characterization is then discussed.`,
      steps: [
        "Intensity",
        "Sound reduction index",
        "Equipment",
        "Practical case<br><span style='font-weight:400'>step-by-step description</span>",
      ],
    },
  },
};

export default principle;
